module.exports = __webpack_public_path__ + "img/automated-circuits.bdd1fa42.png";